import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { AlmanacFileCalendarItem } from '../calendar/types'

type Props = {
  designId: string
}

type Data = AlmanacFileCalendarItem

type Variables = {
  generation_data: Record<string, unknown>
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const applyCarouselChanges = async (workspaceId: number, designId: string, variables: Variables) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${designId}/apply_carousel_changes`, {
    method: 'POST',
    body: variables,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useApplyCarouselChanges = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>((params) => applyCarouselChanges(workspaceId, designId, params), options)
}
